import { type UseQueryResult, useQuery } from 'react-query';
import { VendorCompanyService } from '@wealthlane/api-services/wealthlane-customer-service';

const useGetCompanyStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const customerListData = useQuery(
    ['getCompanyStatus'],
    async () => {
      return await handleRequest(
        VendorCompanyService.getApiCustomerApiAppVendorCompanyCompanyStatuses()
      );
    },
    {
      select: (data) => {
        if (data != null) {
          return data.map((info) => {
            return {
              label: info.name ?? '',
              value: info.id ?? '',
            };
          });
        }
      },
    }
  );

  return customerListData;
};

export default useGetCompanyStatus;
